import { Box, Pagination, Button, useMediaQuery } from '@mui/material';
import React, { useState } from 'react';

import { greenDefault } from 'app/components/ThemeProvider/colors';
import { getTheme } from 'app/components/ThemeProvider/theme';

import EmployeesTable from './EmployeesTable';
import { WorkersCheck } from './EmployeesTable/EmployeesTable';

import { pagination } from './SalaryPage.sx';
import { useChangeWorkersStatus } from 'app/utils/services/salaryServices';
import LoaderFullScreen from 'app/components/LoaderFullScreen';
import { WorkersResponse } from 'app/utils/services/types/salary.type';

interface Props {
  page: number;
  handlePageChange: (event: React.ChangeEvent<unknown>, value: number) => void;
  workers: WorkersResponse;
  workersLoading: boolean;
  refetchWorkers: () => void;
  fetchingWorkers: boolean;
}

const UnEmployeeList = ({
  workers,
  workersLoading,
  refetchWorkers,
  fetchingWorkers,
  page,
  handlePageChange,
}: Props) => {
  const [selectedWorkers, setSelectedWorkers] = useState<WorkersCheck[]>([]);
  const theme = getTheme('light');
  const changeWordersStatus = useChangeWorkersStatus();

  const handleChildData = (data: WorkersCheck[]) => {
    setSelectedWorkers(data);
  };

  const smallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const changeWorkersStatusToUnList = () => {
    changeWordersStatus.mutate(
      {
        id_list: selectedWorkers.map((worker) => worker.id),
        action: 'to_list',
      },
      {
        onSuccess: () => {
          refetchWorkers();
        },
      }
    );
  };

  return (
    <div>
      <>
        {!workersLoading && !fetchingWorkers && (
          <EmployeesTable
            workers={workers?.workers}
            handleChildData={handleChildData}
            refetchWorkers={refetchWorkers}
          />
        )}
        {(workersLoading || fetchingWorkers) && <LoaderFullScreen open={workersLoading || fetchingWorkers} />}
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginTop: '24px',
          }}
        >
          {workers?.total_pages > 1 && (
            <Pagination
              sx={pagination}
              siblingCount={smallScreen ? -1 : 1}
              count={workers?.total_pages}
              page={page}
              onChange={handlePageChange}
              variant="outlined"
              shape="rounded"
            />
          )}
          <Button
            sx={{ backgroundColor: greenDefault, marginLeft: 'auto' }}
            size={'large'}
            color={'info'}
            onClick={changeWorkersStatusToUnList}
            disabled={selectedWorkers.length === 0}
          >
            İşçi siyahısına qaytar
          </Button>
        </Box>
      </>
    </div>
  );
};

export default UnEmployeeList;
